import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  // Patient attention data
  // patientsNeedingAttention: [],
  // listenerActive: false,

  // WhatsApp message configuration
  defaultWhatsAppMessage: 'Olá vou dar continuidade com seu atendimento!',

  // Permissions
  permissions: null,

  // UI state
  loading: false,
  error: null,
  totalWaitingWhatsApp: 0,

  // Painel da IA: mensagens enviadas (as solicitações vêm de state.Agenda, como em Notificações)
  dashboard: {
    loading: false,
    messages: null, // { ai_message, whatsapp_message, ai_appointment } -> { total, period, lastUsedAt }
    messagesError: null,
  },
};

export default function aiReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return {
        ...initState,
      };
    case actions.FETCH_PATIENTS_NEEDING_ATTENTION:
      return {
        ...state,
        loading: true,
        error: null,
        // listenerActive: true,
      };
    case actions.FETCH_PATIENTS_NEEDING_ATTENTION_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsNeedingAttention: action.payload.patients,
        totalWaitingWhatsApp: action.payload.totalWaitingWhatsApp,
      };
    case actions.RESET_PATIENTS_NEEDING_ATTENTION_LISTENER:
      return {
        ...state,
        loading: false,
        patientsNeedingAttention: undefined,
        totalWaitingWhatsApp: 0,
      };
    case actions.FETCH_PATIENTS_NEEDING_ATTENTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.ADD_PATIENT_NEEDING_ATTENTION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.ADD_PATIENT_NEEDING_ATTENTION_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsNeedingAttention: [...state.patientsNeedingAttention, action.payload],
      };
    case actions.ADD_PATIENT_NEEDING_ATTENTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.MARK_PATIENT_AS_ATTENDED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.MARK_PATIENT_AS_ATTENDED_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsNeedingAttention: action.payload.patientsNeedingAttention,
      };
    case actions.MARK_PATIENT_AS_ATTENDED_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.REMOVE_PATIENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.REMOVE_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsNeedingAttention: action.payload.patientsNeedingAttention,
      };
    case actions.REMOVE_PATIENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.UPDATE_PATIENT_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.UPDATE_PATIENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsNeedingAttention: action.payload.patientsNeedingAttention,
      };
    case actions.UPDATE_PATIENT_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actions.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case actions.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    // WhatsApp message cases
    case actions.FETCH_WHATSAPP_MESSAGE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.FETCH_WHATSAPP_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        defaultWhatsAppMessage: action.payload,
      };
    case actions.FETCH_WHATSAPP_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.UPDATE_WHATSAPP_MESSAGE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.UPDATE_WHATSAPP_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        defaultWhatsAppMessage: action.payload,
      };
    case actions.UPDATE_WHATSAPP_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case actions.GET_AI_PERMISSION_SUCCESS:
      return {
        ...state,
        permissions: action.payload.permissions,
      };
    case actions.FETCH_AI_DASHBOARD:
      return {
        ...state,
        dashboard: { ...state.dashboard, loading: true, messagesError: null },
      };
    case actions.FETCH_AI_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboard: {
          loading: false,
          messages: action.payload.messages,
          messagesError: null,
        },
      };
    case actions.FETCH_AI_DASHBOARD_ERROR:
      return {
        ...state,
        dashboard: { loading: false, messages: null, messagesError: action.payload },
      };

    default:
      return state;
  }
}
